import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-copyclipboard',
  templateUrl: './copyclipboard.component.html',
  styleUrls: ['./copyclipboard.component.css']
})
export class CopyclipboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
